import React, { useEffect, useState } from 'react';
import { LegalEntityDto, NaturalPersonDto } from 'api/actor';
import { contractsAPI } from 'services/swagger-api';
import { useContractInfosState } from '../ContractInfosContext';
import { GenericLoading } from 'components/ui/Loader';
import PersonOverview from 'features/person-view/components/PersonOverview';

const ContractPersonOverview: React.FC = () => {
  const { contractId } = useContractInfosState()
  const [person, setPerson] = useState<LegalEntityDto | NaturalPersonDto>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPerson = async () => {
      try {
        setLoading(true);
        setError(null);

        const result = await contractsAPI.getInsureds({ contractId });

        if (result.insureds && result.insureds.length > 0) {
          setPerson(result.insureds[0]);
        } else {
          setError("Aucun asssure n'est lié à ce contrat.");
        }
      } catch (err) {
        setError('Failed to fetch person data');
        console.error('Error fetching person:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPerson();
  }, [contractId]);

  if (loading) {
    return (
      <div className='relative py-4'>
        <GenericLoading isParentSized loading />
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!person) {
    return <div>No person data available</div>;
  }

  return <PersonOverview person={person} />;
};

export default ContractPersonOverview;
